import React from "react";
import { useAppContext } from "../../context/appContext";
import { TextArea, Select } from "../../components/workspace";
import { Address, Contacts, Customer, FileFolder } from "../../components/JobSummary";
import PriceSummary from "../../components/ReviewForm/PriceSummary";
import JobReviewForm from "../../components/ReviewForm";

function JobSummary() {
  const ADMIN_USERS = 1; // the lower the number the more privilages

  const {
    job,
    jobItems,
    options,
    fees,
    discounts,
    contacts,
    lists,
    displayAlert,
    handleChange,
    saveRecord,
    user,
    showReviewForm,
    toggleReviewForm,
  } = useAppContext();

  const reviewOption = job.options_id
    ? options.filter((option) => option.id === job.options_id)[0]
    : options[0];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!job.job_type_id || !job.job_status_id || !job.office_job_notes) {
      displayAlert();
      return;
    }
    saveRecord(`/core-job/update/${job.id}`, job, "job");
  };
  const handleInput = (e) => {
    const name = e.target.name;
    const value = name === "job.office_job_notes" ? e.target.value : Number(e.target.value);
    handleChange({ baseObject: job, name, value });
  };

  const reviewJob = (selectedJob) => {
    console.log("selectedJob:", selectedJob);

    toggleReviewForm(selectedJob);
  };

  let contactOptions = contacts?.filter((cnt) => cnt.id).filter((cnt) => cnt.is_active || cnt.id === job.default_contact);

  return (
    <div className="page">
      {/* ----- Job Info ------ */}
      <div className="group two-thirds">
        <form onSubmit={handleSubmit} className="form">
          <h3>Job Info</h3>
          <div className="form-center">
            <div className="one-half">
              <Select
                name="job.job_status_id"
                labelText="Job Status"
                value={job.job_status_id || "default"}
                handleChange={(e) => handleInput(e)}
                options={lists && lists.listJobStatus}
              />
            </div>
            <div className="one-half">
              <Select
                name="job.default_contact"
                labelText="Current Contact"
                value={job.default_contact}
                handleChange={(e) => handleInput(e)}
                options={contactOptions.map((cnt) => {
                  const contName = cnt.is_active ? cnt.contact_name : cnt.contact_name + " (Inactive)"
                  return { key: cnt.id, text: contName };
                })}
              />
            </div>
            <div className="whole">
              <TextArea
                name="job.office_job_notes"
                labelText="Job Notes"
                value={job.office_job_notes || ""}
                handleChange={(e) => handleInput(e)}
              />
            </div>
          </div>
        </form>
      </div>
      {/* ----- Address ------ */}
      <Address />
      {/* ----- Customer ------ */}
      <Customer />
      {/* ----- Contacts ------ */}
      <Contacts />
      {/* ----- File Folder ------ */}
      <FileFolder />
      {/* ----- Job Review ----- */}
      {(job.job_status_id === 15 || // In Review
        job.job_status_id === 8 || // Completed
        job.job_status_id === 9) && // Warranty Work
        user.user_roles_id <= ADMIN_USERS && (
          <div className="group whole flex-parent">
            {job.job_status_id !== 15 && (
              <PriceSummary
                reviewItems={jobItems}
                reviewFees={fees}
                reviewDiscounts={discounts}
                reviewOption={reviewOption}
                reviewJob={job}
              />
            )}
            <div className="whole">
              <button className="btn" type="button" onClick={() => reviewJob(job)}>
                Review Job
              </button>
            </div>
          </div>
        )}
      {/* ----- Email/ Report Confirmation Modal ------ */}
      <div className={showReviewForm ? "show-modal modal-container" : "modal-container"}>
        <div className="group">
          <JobReviewForm />
        </div>
      </div>
    </div>
  );
}
export default JobSummary;
